import { render, staticRenderFns } from "./biTable.vue?vue&type=template&id=5649b16e&scoped=true"
import script from "./biTable.vue?vue&type=script&lang=js"
export * from "./biTable.vue?vue&type=script&lang=js"
import style0 from "./biTable.vue?vue&type=style&index=0&id=5649b16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649b16e",
  null
  
)

export default component.exports